import { Checkbox } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useMemo, useState } from 'react'
import { LEARNING_MODE } from '../../../constants'
import FlagIcon from '../../../iconsV2/FlagIcon'
import TestIcon from '../../../iconsV2/TestIcon'
import CaseStudyIcon from '../../../iconsV2/CaseStudyIcon'
import Button from '../common/Button'
import { ICourse, IFilter } from '../../../types'
import styles from '../SAPPCalendarFilter.module.css'
import CalendarDrawerMobile from '../common/CalendarDrawerMobile'

interface IProps {
  open: boolean
  onClose: () => void
  filter: IFilter
  setFilter: React.Dispatch<React.SetStateAction<IFilter>>
  courses?: ICourse[]
  onRefetchAPI: (filterDate: Date) => void
}

const FilterCalendarMobile = ({
  open,
  onClose,
  filter,
  setFilter,
  courses,
  onRefetchAPI,
}: IProps) => {
  const [tempFilter, setTempFilter] = useState<IFilter>(filter)

  useEffect(() => {
    setTempFilter(filter)
  }, [filter])

  const noteFilter = useMemo(
    () => [
      {
        title: 'Online',
        icon: <div className={styles['calendar-filter_note_blue']} />,
        value: LEARNING_MODE.ONLINE,
      },
      {
        title: 'Live Online',
        icon: <div className={styles['calendar-filter_note_pureple']} />,
        value: LEARNING_MODE.LIVE_ONLINE,
      },
      {
        title: 'Offline',
        icon: <div className={styles['calendar-filter_note_green']} />,
        value: LEARNING_MODE.OFFLINE,
      },
      {
        title: 'Holiday',
        icon: <div className={styles['calendar-filter_note_yellow']} />,
        value: LEARNING_MODE.HOLIDAY,
      },
      {
        title: 'Overdue',
        icon: <div className={styles['calendar-filter_note_red']} />,
        value: LEARNING_MODE.OVERDUE,
      },
      { title: 'Test', icon: <TestIcon />, value: LEARNING_MODE.TEST },
      {
        title: 'Case Study',
        icon: <CaseStudyIcon />,
        value: LEARNING_MODE.CASE_STUDY,
      },
      {
        title: 'Key Content Before',
        icon: <FlagIcon />,
        value: LEARNING_MODE.KEY_BEFORE_CONTENT,
      },
    ],
    []
  )

  const handleTempFilter = (value: string) => {
    setTempFilter((prev) => {
      const updated = prev.type?.includes(value)
        ? prev.type.filter((item) => item !== value)
        : [...(prev.type || []), value]
      return { ...prev, type: updated }
    })
  }

  const handleConfirm = () => {
    setFilter({ ...tempFilter, isOpen: false })
    if (tempFilter.day) {
      onRefetchAPI(dayjs(tempFilter.day).toDate())
    }
    onClose()
  }

  return (
    <CalendarDrawerMobile
      title='Sort Filter'
      open={open}
      onClose={onClose}
    >
      <div className="flex flex-col gap-4">
          {noteFilter.map((item) => (
            <div
              key={item.value}
              className="flex items-center justify-start gap-2"
              onClick={() => handleTempFilter(item.value)}
            >
              <Checkbox
                checked={tempFilter.type?.includes(item.value)}
                className={styles['custom-checkbox']}
              />
              <div className="flex items-center gap-2">
                {item.icon}
                <span>{item.title}</span>
              </div>
            </div>
          ))}
      </div>
       <div className="mt-4">
          <Button color="primary" fullWidth onClick={handleConfirm}>
            Confirm
          </Button>
        </div>
    </CalendarDrawerMobile>
  )
}

export default FilterCalendarMobile
